export const MOBILE_DEVICE_MAX_WIDTH = 479;
export const TABLET_DEVICE_MAX_WIDTH = 767;
export const DESKTOP_DEVICE_MAX_WIDTH = 1023;
export const LARGE_DESKTOP_DEVICE_MAX_WIDTH = 1199;
